import {ApiBind, CommonSearchParam} from "@app/core/models/common-search-param.model";

/**
 * 広告リクエストパラメータテンプレート検索パラメータクラス
 * @remarks
 * 広告リクエストパラメータテンプレート検索パラメータ情報を格納するクラス
 */
export class AdRequestParameterTemplateSearchParam extends CommonSearchParam {

    constructor(
        name?: string,
        deliveryScopes?: number[],
        platformId?: number,
        adFormats?: number[],
        adRequestFormatTemplateName?: string,
) {
        super();
        this.name = name;
        this.deliveryScopes = deliveryScopes;
        this.platformId = platformId;
        this.adFormats = adFormats;
        this.adRequestFormatTemplateName = adRequestFormatTemplateName;
    }
    // 広告リクエストパラメータテンプレート名
    @ApiBind({ column: 'template_parameter_name' })
    name: string;
    // 配信面
    @ApiBind({ column: 'delivery_scopes' })
    deliveryScopes: number[];
    // プラットフォームID
    @ApiBind({ column: 'platform_id' })
    platformId: number;
    // フォーマット
    @ApiBind({ column: 'ad_formats' })
    adFormats: number[];
    // 広告リクエストフォーマットテンプレート名
    @ApiBind({ column: 'ad_request_format_template_name' })
    adRequestFormatTemplateName: string;

}
